import $ from 'jquery'

function header () {
  const $navToggle = $('.nav-toggle')
  const $navMenu   = $('#nav-menu')
  const $searchRoot = $('[data-nav-search]')
  const $searchToggle = $searchRoot.find('[data-nav-search-toggle]')
  const $searchPanel = $searchRoot.find('[data-nav-search-panel]')

  // ─── Mobile toggle ────────────────────────────────────────────────────────
  $navToggle.on('click', function () {
    const isOpen = $navMenu.hasClass('open')
    $navMenu.toggleClass('open', !isOpen)
    $navToggle.attr('aria-expanded', String(!isOpen))
    $navToggle.attr('aria-label', isOpen ? 'Open menu' : 'Close menu')
  })

  // Close nav when a link is clicked (mobile UX)
  $navMenu.on('click', 'a', function () {
    $navMenu.removeClass('open')
    $navToggle.attr('aria-expanded', 'false')
    $navToggle.attr('aria-label', 'Open menu')
  })

  // ─── Header search toggle ────────────────────────────────────────────────
  const closeSearch = () => {
    if (!$searchRoot.length) return
    $searchRoot.removeClass('is-open')
    $searchPanel.attr('hidden', true)
    $searchToggle.attr('aria-expanded', 'false')
    $searchToggle.attr('aria-label', 'Open search')
  }

  const openSearch = () => {
    if (!$searchRoot.length) return
    $searchRoot.addClass('is-open')
    $searchPanel.removeAttr('hidden')
    $searchToggle.attr('aria-expanded', 'true')
    $searchToggle.attr('aria-label', 'Close search')

    const input = $searchPanel.find('input[type="search"], input[type="text"], .is-search-input').get(0)
    if (input) {
      window.setTimeout(() => input.focus(), 0)
    }
  }

  if ($searchRoot.length) {
    $searchToggle.on('click', function (event) {
      event.preventDefault()
      event.stopPropagation()
      if ($searchRoot.hasClass('is-open')) {
        closeSearch()
      } else {
        openSearch()
      }
    })

    $(document).on('click.navSearch', function (event) {
      if (!$searchRoot.hasClass('is-open')) return
      if ($(event.target).closest('[data-nav-search]').length) return
      closeSearch()
    })

    $(document).on('keydown.navSearch', function (event) {
      if (event.key === 'Escape') {
        closeSearch()
        $searchToggle.trigger('focus')
      }
    })
  }

  // ─── Scroll class ────────────────────────────────────────────────────────
  $(window).on('scroll.header', function () {
    $('body').toggleClass('scrolled', $(window).scrollTop() > 10)
  })

  // ─── Info bar ────────────────────────────────────────────────────────────
  const $infoBar      = $('.header__info-bar')
  const $infoBarClose = $('.header__info-bar__close')

  if ($infoBar.length && !getCookie('header-bar')) {
    $infoBar.removeClass('header__info-bar--closed')
  }

  $infoBarClose.on('click', function () {
    $infoBar.slideUp(function () {
      $infoBar.addClass('header__info-bar--closed')
    })
    setCookie('header-bar', 'true', 3)
  })

  // ─── Cookie helpers ───────────────────────────────────────────────────────
  function setCookie (name, value, days) {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }

  function getCookie (name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return false
  }
}

export { header }
